import type { HoleRange } from '@/lib/db/types';

export function holeRangeIndices(holes: HoleRange): { start: number; end: number; indices: number[] } {
  if (holes === 'front-9') {
    return { start: 0, end: 9, indices: Array.from({ length: 9 }, (_, i) => i) };
  }
  if (holes === 'back-9') {
    return { start: 9, end: 18, indices: Array.from({ length: 9 }, (_, i) => i + 9) };
  }
  return { start: 0, end: 18, indices: Array.from({ length: 18 }, (_, i) => i) };
}
